






























import Vue from 'vue';
import {AmendmentViewModel} from "@/models/AmendmentViewModel";
import AmendmentForm from "@/components/amendments/AmendmentForm.vue";
import {ReturnDataViewModel} from "@/models/ReturnDataViewModel";
import {UserViewModel} from "@/models/UserViewModel";

export default Vue.extend ({
  name: "AmendmentEdit" ,
  components: {
    AmendmentForm,
  },
  data(): {
    amendment: AmendmentViewModel
    itemId: number
    formSaving: boolean
    workAreaList: any[]
  }{
    return {
      amendment: {} as AmendmentViewModel ,
      itemId: 0,
      formSaving: false,
      workAreaList: []
    }
  },
  mounted() {
    this.getWorkAreaList();
    if ( this.$route.params.id) {
      this.itemId = parseInt(this.$route.params.id as string);
      this.getAmendment();
    }
  },
  computed: {
    loggedInUser(): UserViewModel {
      return this.$store.state.loggedInUser;
    },
  },
  methods: {
    async getWorkAreaList() {
      const results = await this.axios.get('/Lookups/GetWorkAreas');
      this.workAreaList = results.data;
    },
    async getAmendment() {
      let result = await this.axios.get( '/Amendments/GetOne' , {
        params: {
          id: this.itemId }
      });
      this.amendment = result.data;
    },
    async loadData() {
      if ( this.itemId> 0 ){
        let result = await this.axios.get( '/Amendments/GetOne' , {
          params: {
            id: this.itemId }
        });
        this.amendment = result.data;
      }
    },
    async handleSave() {
      let result = await this.axios.post('/Amendments/PostAmendment', this.amendment , { headers: { "Content-Type": "application/json"} } );
      // eslint-disable-next-line
      const data = result.data as unknown as ReturnDataViewModel;
      await this.$router.push({name: "amendments-detail", params: {id: this.amendment.amendmentId.toString()}});
    },
    async updateAmendment() {
      try {
        this.formSaving = true;

        let tempWA = this.workAreaList.find( w => w.abbreviation === this.amendment.workAreaAbbreviation );
        this.amendment.workArea = tempWA.displayValue;
        this.amendment.workAreaType = tempWA.category;

        const result = await this.axios.post( '/Amendments/PostAmendment', this.amendment, { headers: { "Content-Type": "application/json"} } );
        const data = result.data as unknown as ReturnDataViewModel;
        const returnedId = data.idReturned.toString();

        if ( result.status === 200 ) {
          await this.$router.push( { name: "amendments-detail" , params: { id: returnedId.toString() } } );
        }

      } catch (err) {
        if (err.response.status === 400 || err.response.status === 403 || err.response.status === 404 || err.response.status === 409) {
          console.log(err.response.data.message)
        }
      }
      finally {
        this.formSaving = false;
      }

    }
  },
  beforeCreate() {
    setTimeout( async () => {
      if ( this.$store.state.loggedInUser == null ) {
        //make one attempt to get the current user info
        try {
          let result = await this.axios.get('Users/GetUserFromToken');
          if ( result.status === 200 ) {
            await this.$store.dispatch('updateUser', result.data);
          }
        } catch ( err ) {
          if ( err.response.status === 400  ) {
            await this.$router.push('/Login');
          }
        }
      }
    } , 250 );
  },

} )
